import React from 'react'

import Stars from 'client/components/Stars'

import { getSuggestionIcon } from './utils'
import { SuggestionType } from 'src/types/search'
import noop from 'lodash/noop'

import styles from './styles.module.css'

interface ISuggestionItemProps {
  item?: SuggestionType
  onClick?: () => void
}

const Suggestion = ({ item, onClick = noop }: ISuggestionItemProps) => {
  if (!item) {
    return null
  }

  const LocationTypeIcon = getSuggestionIcon(item.Type)

  return (
    <li
      className={styles.suggestionBase}
      data-testid="suggester-option"
      onClick={onClick}
      aria-hidden
    >
      <div className={styles.iconContainer}>
        <LocationTypeIcon size={20} />
      </div>
      <div className={styles.textContent}>
        <div className={styles.locationName}>
          <p>{item.Text}</p> {item.Type === 'hotel' && <Stars stars={item.Stars} color="grey1" />}
        </div>
        <p className={styles.locationInfo}>{item.Description}</p>
      </div>
    </li>
  )
}

export default Suggestion
